import { post } from '../axios'

// 删除标签
export function activityTag_deleteTag_post(map, option) {
  return post(
    `${process.env.VUE_APP_ACTIVITYTAG}/activityTag/deleteTag`,
    map,
    option
  ).then(response => response)
}

// 查询标签详情
export function activityTag_queryTagDetail_post(map, option) {
  return post(
    `${process.env.VUE_APP_ACTIVITYTAG}/activityTag/queryTagDetail`,
    map,
    option
  ).then(response => response)
}

// 查询标签列表
export function activityTag_queryTagList_post(map, option) {
  return post(
    `${process.env.VUE_APP_ACTIVITYTAG}/activityTag/queryTagList`,
    map,
    option
  ).then(response => response)
}

// 新增/编辑标签
export function activityTag_upsertTag_post(map, option) {
  return post(
    `${process.env.VUE_APP_ACTIVITYTAG}/activityTag/upsertTag`,
    map,
    option
  ).then(response => response)
}

// 调整标签顺序
export function activityTag_modifyTagPosition_post(map, option) {
  return post(
    `${process.env.VUE_APP_ACTIVITYTAG}/activityTag/modifyTagPosition`,
    map,
    option
  ).then(response => response)
}
